import { z } from 'zod';

// For /login/, the request body is unused; we authorize with the Bearer token header.
// Define an empty payload type for consistency with other endpoints.
export type LoginPayload = Record<string, never>;

export const RegisterPayloadSchema = z.object({
  username: z.string().trim().min(1, 'profile-editor.validation.username-required'),
  is_private: z.boolean(),
});

export type RegisterPayload = z.infer<typeof RegisterPayloadSchema>;
